import {colors} from '../../../constants'

/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            color: 'black'
        },
        list: {
            display: 'flex',
            flexDirection: 'column',
            gap: '4px',
            fontSize: '16px'
        },
        headingLink: {
            display: 'inline-flex'
        },
        heading: {
            fontFamily: 'Roboto, sans-serif',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '0.24px'
        }
    },
    variants: {
        vertical: {
            listItem: {
                marginTop: '0px !important',
                fontFamily: 'Raleway',
                fontSize: '16px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: '24px'
            }
        },
        horizontal: {
            listItem: {
                borderLeft: '1px solid',
                paddingLeft: 2,
                fontSize: '16px',
                lineHeight: '18.75px',
                fontWeight: '300',
                color: colors.textLight
            },
            listItemSx: {
                '&:first-of-type': {
                    borderLeft: 0,
                    paddingLeft: 0
                }
            }
        }
    },
    defaultProps: {
        variant: 'vertical'
    }
}
